import { JobFitAlignment } from '../../services/job.service';

export type JobFitPhase =
  | 'idle'
  | 'working'
  | 'payment'
  | 'completed'
  | 'failed';

export const JOB_FIT_PROGRESS_PERCENT: Record<string, number> = {
  QUEUED: 20,
  PROCESSING: 60,
  COMPLETED: 100,
  FAILED: 0,
};

export const JOB_FIT_ALIGNMENT_CLASS: Record<JobFitAlignment, string> = {
  STRONG: 'job-fit-score--strong',
  MODERATE: 'job-fit-score--moderate',
  WEAK: 'job-fit-score--weak',
};

export function formatAlignmentLabel(alignment: JobFitAlignment): string {
  return `${alignment.charAt(0)}${alignment.slice(1).toLowerCase()} fit`;
}

export function visibleSkills(
  skills: string[],
  limit: number
): {
  visible: string[];
  remaining: number;
} {
  if (skills.length <= limit) {
    return { visible: skills, remaining: 0 };
  }
  return { visible: skills.slice(0, limit), remaining: skills.length - limit };
}

export const JOB_FIT_DISCLAIMER =
  'This is an automated assessment for your reference only. It does not guarantee review, shortlisting, or selection in the employer\u2019s hiring process.';
